import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogContent from "@mui/material/DialogContent"
import { DialogTitle, IconButton, DialogActions } from "@mui/material"
import TextField from "@mui/material/TextField"
import Typography from "@mui/material/Typography"
import Grid from "@mui/material/Unstable_Grid2" // Grid version 2
import React, { useContext } from "react"
import { useDispatch, useSelector } from "react-redux"
import { yupResolver } from "@hookform/resolvers/yup"
import { FormProvider, useForm } from "react-hook-form"
import * as yup from "yup"
import TokenContext from "../../context/TokenContext"
import { obtenerDisciplinas, obtenerSubdisciplinas, obtenerUniversidades } from "../../Redux/autocompletados"
import { UserAuth } from "../../context/AuthContext"
import CustomSelect from "../CustomSelect"
import CustomSearchSelect from "../CustomSearchSelect"
import CustomTextField from "../CustomTextField"
import CustomDateField from "../CustomDateField"

const ModalTrayectorias = ({ open, handleClose, onSubmit }) => {
    const token = useContext(TokenContext)
    const dispatch = useDispatch()
    const { empleado } = UserAuth()

    const [universidades, setUniversidades] = React.useState([])
    const loadingUniversidades = useSelector((store) => store.autocompletados.loadingUniversidades);

    const [disciplinas, setDisciplinas] = React.useState([])
    const disciplinasSelector = useSelector((store) => store.autocompletados.disciplinas);

    const [subdisciplinas, setSubdisciplinas] = React.useState([])
    const subDisciplinasSelector = useSelector(store => store.autocompletados.subdiciplinas)

    React.useEffect(() => {
        if (token) {
            dispatch(obtenerUniversidades(token))
            dispatch(obtenerDisciplinas(token))
            dispatch(obtenerSubdisciplinas(token));
        }
    }, [token]);

    React.useEffect(() => {
        if (loadingUniversidades?.length > 0) {
            const universidades = [];
            loadingUniversidades.forEach((item) => {
                const object = {
                    value: item.new_universidadid,
                    label: item.new_name,
                };
                universidades.push(object);
            });
            setUniversidades(universidades);
        }
    }, [loadingUniversidades])

    React.useEffect(() => {
        if (disciplinasSelector?.length > 0) {
            const disciplina = [];
            disciplinasSelector.forEach((item) => {
                const object = {
                    value: item.new_disciplinaid,
                    label: item.new_name,
                };
                disciplina.push(object);
            });
            setDisciplinas(disciplina);
        }
    }, [disciplinasSelector])

    React.useEffect(() => {
        if (subDisciplinasSelector.length > 0) {
            var array = []
            subDisciplinasSelector.forEach(element => {
                var objeto = {
                    label: element.new_name,
                    value: element.new_subdisciplinaid
                }
                array.push(objeto)
            });
            setSubdisciplinas(array)
        }
    }, [subDisciplinasSelector])

    const defaultValues = {
        new_tipodetrayectoria: '',
        new_institucinacadmica: '',
        new_funcion: '',
        new_designacin: '',
        new_fechadeinicio: '',
        new_duracindelcursado: '',
        new_disciplina: '',
        new_subdisciplina: '',
        new_cargo: '',
        new_unidadacadmica: '',
        new_otrocargofuncin: '',
        new_fechadefinalizacin: '',
        new_dedicacinsemanal: '',
    }

    const validacionSchema = yup.object().shape({
        new_tipodetrayectoria: yup.number().required("Required"),
        new_cargo: yup.number().required("Required"),
        new_institucinacadmica: yup.object({value: yup.string().required("Required") }),
        new_designacin: yup.number().required("Required"),
        new_fechadeinicio: yup.string().required("Required"),
        new_dedicacinsemanal: yup.number().required("Required"),
    })

    const methods = useForm({
        shouldUnregister: false,
        defaultValues,
        resolver: yupResolver(validacionSchema),
        mode: "onChange",
        shouldFocusError: true,
    })

    const { handleSubmit, reset } = methods

    const submitDatos = (datos) => {
        onSubmit(datos)
    }

    const opcionesTipo = [
        { label: 'Nivel Superior Universitario y/o Posgrado', value: 100000000 },
        { label: 'Gestión Académica', value: 100000001 },
        { label: 'Desempeño no Académico', value: 100000002 },
        { label: 'I+D', value: 100000003 },
    ]

    const opcionesFuncion = [
        { label: 'Ejecutiva/Directiva', value: 100000000 },
        { label: 'De Asesoramiento Especializado', value: 100000001 },
        { label: 'Otra', value: 100000002 },
    ]

    const opcionesDesignacion = [
        { label: 'Regular Rentado', value: 100000000 },
        { label: 'Regular Ad Honoren', value: 100000001 },
        { label: 'Contratado', value: 100000002 },
        { label: 'Interino Rentado', value: 100000003 },
        { label: 'Interino Ad Honoren', value: 100000004 },
        { label: 'Concursado', value: 100000005 },
    ]

    const opcionesDuracion = [
        { label: 'Semestral', value: 100000000 },
        { label: 'Cuatrimestral', value: 100000001 },
        { label: 'Bimestral', value: 100000002 },
        { label: 'Mensual', value: 100000003 },
    ]

    const opcionesCargo = [
        { label: 'Profesor Titular', value: 100000000 },
        { label: 'Profesor Adjunto', value: 100000001 },
        { label: 'Director', value: 100000002 },
        { label: 'Secretario', value: 100000003 },
        { label: 'Otro', value: 100000004 },
        { label: 'Asesor', value: 100000005 },
        { label: 'Profesor Asociado', value: 100000006 },
        { label: 'Jefe de Trabajos Prácticos', value: 100000007 },
        { label: 'Ayudante Graduado', value: 100000008 },
        { label: 'Ayudante No Graduado', value: 100000009 },
    ]

    const opcionesUnidad = [
        { label: 'Escuela de Graduados', value: 100000000 },
        { label: 'Rectorado', value: 100000001 },
        { label: 'Otros', value: 100000002 },
    ]

    const opcionesDedicacion = [
        { label: 'De 0 hasta 19 horas', value: 100000000 },
        { label: 'De 20 hasta 39 horas', value: 100000001 },
        { label: '40 horas o más', value: 100000002 },
    ]


    return (
        <Dialog
            fullWidth={true}
            maxWidth={'md'}
            open={open}
            onClose={handleClose}
        >
            <DialogTitle>Crear trayectoria docente</DialogTitle>
            <FormProvider {...methods}>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid xs={12} sm={6} item sx={{ pt: 0, pb: 0 }}>
                            <CustomSelect
                                fullWidth
                                name="new_tipodetrayectoria"
                                label="Tipo de trayectoria"
                                helperText="Por favor seleccione un valor"
                                options={opcionesTipo}
                                rules={{ required: "Required!" }}
                                required={true}
                                className="custom-helper"
                            />
                        </Grid>
                        <Grid xs={12} sm={6} item sx={{ pt: 0, pb: 0 }}>
                            <CustomSearchSelect
                                options={universidades}
                                type="text"
                                name="new_institucinacadmica"
                                lab="Institución Académica"
                                req={true}
                            />
                        </Grid>
                        <Grid xs={12} sm={6} item sx={{ pt: 0, pb: 0 }}>
                            <CustomSelect
                                fullWidth
                                name="new_cargo"
                                label="Cargo"
                                helperText="Por favor seleccione un valor"
                                options={opcionesCargo}
                                rules={{ required: "Required!" }}
                                required={true}
                                className="custom-helper"
                            />
                        </Grid>
                        <Grid xs={12} sm={6} item sx={{ pt: 0, pb: 0 }}>
                            <CustomSelect
                                fullWidth
                                name="new_funcion"
                                label="Función"
                                helperText="Por favor seleccione un valor"
                                options={opcionesFuncion}
                                rules={{ required: "Required!" }}
                                className="custom-helper"
                            />
                        </Grid>
                        <Grid xs={12} sm={6} item sx={{ pt: 0, pb: 0 }}>
                            <CustomSelect
                                fullWidth
                                name="new_unidadacadmica"
                                label="Unidad académica"
                                helperText="Por favor seleccione un valor"
                                options={opcionesUnidad}
                                rules={{ required: "Required!" }}
                                className="custom-helper"
                            />
                        </Grid>
                        <Grid xs={12} sm={6} item sx={{ pt: 0, pb: 0 }}>
                            <CustomSelect
                                fullWidth
                                name="new_designacin"
                                label="Designación"
                                helperText="Por favor seleccione un valor"
                                options={opcionesDesignacion}
                                rules={{ required: "Required!" }}
                                required={true}
                                className="custom-helper"
                            />
                        </Grid>
                        <Grid xs={12} sm={6} item sx={{ pt: 0, pb: 0 }}>
                            <CustomTextField
                                Component={TextField}
                                name="new_otrocargofuncin"
                                label="Otro Cargo/Función"
                                rules={{ required: "Required!" }}
                                helperText="Por favor indica el título."
                                className="custom-helper"
                            />
                        </Grid>
                        <Grid xs={12} sm={6} item sx={{ mt: 1 }}>
                            <CustomDateField
                                name="new_fechadeinicio"
                                label="Fecha de inicio:"
                                rules={{ required: "Required!" }}
                                helperText="Por favor indica la fecha de inicio"
                                req={true}
                                className="custom-helper"
                            />
                        </Grid>
                        <Grid xs={12} sm={6} item sx={{ mt: 1 }}>
                            <CustomDateField
                                name="new_fechadefinalizacin"
                                label="Fecha de finalización:"
                                rules={{ required: "Required!" }}
                                helperText="Por favor indica la fecha de finalización"
                                className="custom-helper"
                            />
                        </Grid>
                        <Grid xs={12} sm={6} item sx={{ pt: 0, pb: 0 }}>
                            <CustomSelect
                                fullWidth
                                name="new_duracindelcursado"
                                label="Duración del Cursado"
                                helperText="Por favor seleccione un valor"
                                options={opcionesDuracion}
                                rules={{ required: "Required!" }}
                                className="custom-helper"
                            />
                        </Grid>
                        <Grid xs={12} sm={6} item sx={{ pt: 0, pb: 0 }}>
                            <CustomSelect
                                fullWidth
                                name="new_dedicacinsemanal"
                                label="Dedicación Semanal"
                                helperText="Por favor seleccione un valor"
                                options={opcionesDedicacion}
                                rules={{ required: "Required!" }}
                                required={true}
                                className="custom-helper"
                            />
                        </Grid>
                        <Grid xs={12} sm={6} item sx={{ pt: 0, pb: 0 }}>
                            <CustomSearchSelect
                                options={disciplinas}
                                type="text"
                                name="new_disciplina"
                                lab="Disciplina"
                            />
                        </Grid>
                        <Grid xs={12} sm={6} item sx={{ pt: 0, pb: 0 }}>
                            <CustomSearchSelect
                                options={subdisciplinas}
                                type="text"
                                name="new_subdisciplina"
                                lab="Subdisciplina"
                            />
                        </Grid>

                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => handleClose()} color="secondary" >
                        <Typography sx={{ fontWeight: 'bold' }}>Cerrar</Typography>
                    </Button>
                    <Button
                        type="submit"
                        variant="text"
                        color="secondary"
                        onClick={handleSubmit(submitDatos)}
                    >
                        <Typography sx={{ fontWeight: 'bold' }}>Crear</Typography>
                    </Button>
                </DialogActions>
            </FormProvider>
        </Dialog>
    )
}

export default ModalTrayectorias